// src/plugins/vuetify.js
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Import Vuetify's CSS
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // For Material Design Icons

export default createVuetify({
  theme: {
    themes: {
      light: {
        primary: '#e5c002', // Set the primary theme color
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
});
